import type { PaymentTypeType } from '@/types/domain/photo/valueObjects/paymentType';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';
import { PAYMENT_TYPE_TYPE } from '@/types/domain/photo/valueObjects/paymentType';

export class PaymentType extends PrimitiveValueObject<PaymentTypeType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: PaymentTypeType): PaymentType {
    return new PaymentType(value);
  }

  /** リスト */
  static get list(): {
    /** ID */
    id: string,
    /** 名前 */
    name: string,
  }[] {
    const items = [];
    for (let i = 0; i < PAYMENT_TYPE_TYPE.length; i += 1) {
      items.push({
        id: PAYMENT_TYPE_TYPE[i],
        name: PAYMENT_TYPE_TYPE[i],
      });
    }
    return items;
  }
}
